export const addFunds = (fund) => ({
  type: 'ADD_FUNDS',
  payload: fund,
});

export const setFunds = (funds) => ({
  type: 'SET_FUNDS',
  payload: funds,
});

export const updateFunds = (fund) => ({
  type: 'UPDATE_FUNDS',
  payload: fund, 
});

export const setError = (error) => ({
  type: 'SET_ERROR',
  payload: error,
});